import React from 'react';
import PropTypes from 'prop-types';

import Button from 'common/components/Button';

import { TranslatedTextMessage } from './TranslatedTextMessage';

import { AgeGateContext } from 'apps/age_gate/ageGateContext';

const DisagreeButton = ({ minimum_age }) => {
  const { messageKeys, translationMessages } = React.useContext(AgeGateContext);

  return (
    <Button
      id="age-gate-disagree-button"
      className="age-gate__disagree-button"
      element="a"
      href={translationMessages[messageKeys['DISAGREE_URL']]}
    >
      <TranslatedTextMessage
        id={'DISAGREE_TEXT'}
        inlineData={{ age: minimum_age }}
      />
    </Button>
  );
};

DisagreeButton.propTypes = {
  minimum_age: PropTypes.number.isRequired,
};

export default DisagreeButton;
